import React from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import outletIcon from 'assets/images/backoffice/outlet-Icon.svg';
import { setSelectedOutletIds } from 'actions/actionBar';
import { showModalOutletMobile } from 'actions';
import styles from './style.css';

class OutletModal extends React.Component {
  render() {
    const {
      outlets,
      allOutletOption,
      input: { value },
    } = this.props;
    const allOutlet = {
      id: outlets.map(outlet => outlet.id),
      name: 'All',
    };
    const countOfOutlet = 6;

    return (
      <Modal
        show={this.props.show}
        onHide={this._onHideOutletModal}
        id="outletModal"
        bsClass={
          outlets.length >= countOfOutlet
            ? `${styles.setAutoHeight} outlet-modal modal`
            : `${styles.unSetHeight} outlet-modal modal`
        }
        backdrop
      >
        <Modal.Body>
          <li className={`list-group-item all-item ${styles['outlet-hover']}`}>
            <span className="select-outlet">
              <img
                alt="Outlet icon"
                className={styles['outlet-icon']}
                src={outletIcon}
              />
              <span>Select Outlet</span>
            </span>
          </li>
          <ul className="list-group text-center">
            {allOutletOption && outlets.length > 1 && (
              <li
                key={0}
                className={`list-group-item ${styles['outlet-hover']}`}
                role="presentation"
              >
                <Link
                  className={
                    value.length > 1
                      ? styles['outlet-link-selected']
                      : styles['outlet-link']
                  }
                  onClick={() => {
                    this._onChangeOutlet(allOutlet.id);
                    this._onChangeOutletIds(allOutlet.id);
                    this._onHideOutletModal();
                  }}
                  data-dismiss="modal"
                >
                  All Outlet
                </Link>
              </li>
            )}
            {outlets.map(outlet => {
              return (
                <li
                  key={outlet.id}
                  className={`list-group-item ${styles['outlet-hover']}`}
                  role="presentation"
                >
                  <Link
                    className={
                      value[0] === outlet.id && value.length < 2
                        ? styles['outlet-link-selected']
                        : styles['outlet-link']
                    }
                    onClick={() => {
                      this._onChangeOutlet([outlet.id]);
                      this._onChangeOutletIds([outlet.id]);
                      this._onHideOutletModal();
                    }}
                    data-dismiss="modal"
                  >
                    {outlet.name}
                  </Link>
                </li>
              );
            })}
          </ul>
        </Modal.Body>
      </Modal>
    );
  }

  _onChangeOutlet = outletIds => {
    const {
      input: { onChange },
      meta: { dispatch },
    } = this.props;
    dispatch(setSelectedOutletIds(outletIds));
    onChange(outletIds);
  };

  _onChangeOutletIds = outletIds => {
    this.props.onChangeOutletIds(outletIds);
  };

  _onHideOutletModal = () => {
    const {
      meta: { dispatch },
    } = this.props;
    dispatch(showModalOutletMobile(false));
  };
}

OutletModal.propTypes = {
  outlets: PropTypes.array,
};

export default OutletModal;
